import React from 'react';
import { navigate } from 'gatsby';
import styled, { css } from 'styled-components';
import {
  brandColours,
  brandFonts,
  fontSize,
  fontWeights,
  maxBreakpointQuery,
  minBreakpointQuery,
  standardColours,
  visuallyHidden,
} from '../styles';
import { Image, Link } from './ui';
import arrowIcon from '../images/arrow-icon.bg.svg';

const StyledMegaMenuBannersCta = styled.div`
  ${maxBreakpointQuery.mlarge`
    ${visuallyHidden()};
  `}

  ${minBreakpointQuery.mlarge`
    display: grid;
    grid-auto-rows: 1fr;
    gap: 20px;
    padding: 30px 30px 30px 0;
  `}
`;

const StyledBanner = styled.article`
  ${minBreakpointQuery.mlarge`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: end;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
  `}
`;

const StyledImage = styled(Image)`
  ${minBreakpointQuery.mlarge`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `}
`;

const StyledContent = styled.div`
  ${minBreakpointQuery.mlarge`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 10px;
    padding: 40px 20px 20px;
    height: 100%;
    color: ${standardColours.white};
    background: linear-gradient(
      to bottom,
      transparent 0%,
      ${standardColours.black} 80%
    );
  `}
`;

const StyledLabel = styled.span`
  ${minBreakpointQuery.mlarge`
    margin-bottom: auto;
    margin-right: auto;
    ${fontSize(14)};
    background-color: ${brandColours.tertiary};
    padding: 6px 10px;
    border-radius: 5px;
  `}
`;

const StyledHeading = styled.p`
  ${({ hasText }) => {
    if (hasText) {
      return css`
        ${minBreakpointQuery.mlarge`
          ${brandFonts.secondary};
          ${fontSize(26)};
          line-height: 1.2;
        `}
      `;
    } else {
      return css`
        ${minBreakpointQuery.mlarge`
          position: relative;
          padding-right: 30px;
          font-weight: ${fontWeights.medium};
        `}

        &:after {
          ${minBreakpointQuery.mlarge`
            content: '';
            position: absolute;
            top: 50%;
            right: 0;
            width: 21px;
            height: 14px;
            background: url(${arrowIcon}) no-repeat center / 100%;
            filter: brightness(0) invert(1);
            transform: translateY(calc(-50% + 1px));
          `}
        }
      `;
    }
  }}

  strong {
    ${minBreakpointQuery.mlarge`
      font-weight: inherit;
    `}
  }
`;

const StyledText = styled.p`
  ${minBreakpointQuery.mlarge`
    font-weight: ${fontWeights.medium};
    line-height: 1.6;
  `}
`;

const MegaMenuBannersCta = ({ items }) => (
  <StyledMegaMenuBannersCta>
    {items.map(({ heading, image, label, text, url }, id) => (
      <StyledBanner
        key={id}
        onClick={() => {
          navigate(url);
        }}
      >
        <StyledImage
          src={image.url}
          alt={image.title}
          width={290}
          height={390}
          layout="constrained"
        />
        <StyledContent>
          {label && <StyledLabel>{label}</StyledLabel>}
          <StyledHeading hasText={text}>
            <strong>
              <Link to={url}>{heading}</Link>
            </strong>
          </StyledHeading>
          {text && <StyledText>{text}</StyledText>}
        </StyledContent>
      </StyledBanner>
    ))}
  </StyledMegaMenuBannersCta>
);

export default MegaMenuBannersCta;
